import { FaExternalLinkAlt, FaEye } from "react-icons/fa";
import Tooltip from "../ToolTip";

const DetailsButton = ({ action, content, type = "eye" }) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action ? action() : null}
        className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-blue-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
        {type === "eye" ? <FaEye className="text-[10px]"/> : 
         type === "externalLink" ? <FaExternalLinkAlt className="text-[10px]"/> : null}
      </button>
    </Tooltip>
  )
}

export default DetailsButton;